module.exports = __webpack_public_path__ + "img/criticaledition_introduction.2babd3ec.svg";